import { format } from 'date-fns';
import { defaultDateFormat } from './constants';
import getLocale from './getLocale';

const getDate = (dateFormat = defaultDateFormat) => format(new Date(), dateFormat, { locale: getLocale() });

export default getDate;
